import { ConfirmationDeleteComponent } from '../../../components/modals/confirmation-delete/confirmation-delete.component';
import { UserCreateComponent } from './../user-create/user-create.component';
import { SuperService } from './../../../core/services/super.service';
import { Employees } from './../../../core/models/employees.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UserState } from '../state/user.reducer';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

import * as fromUserSelectors from '../state/user.selectors';
import * as fromUserActions from '../state/user.actions';

export interface UserManagement {
	'custom:organization': string;
	'custom:role': string;
	email: string;
	email_verified: string;
	locale: string;
	name: string;
	sub: string;
}

@Component({
	selector: 'app-user-management',
	templateUrl: './user-management.component.html',
	styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit {
	users: [any?] = [];
	superUser = Boolean(localStorage.getItem('superUser'));
	adminUser = Boolean(localStorage.getItem('adminUser'));

	displayedColumns: string[] = [
		'name',
		'email',
		'organization',
		'function',
		'actions',
	];

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	dataSource: MatTableDataSource<any>;

	loading$: Observable<boolean>;
	searchForm: FormGroup;
	loading = true;

	list = [];

	constructor(
		private superService: SuperService,
		private store: Store<UserState>,
		private toastr: ToastrService,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private paginatorTranslator: MatPaginatorIntl
	) {}

	ngOnInit(): void {
		this.translateTable();

		if (!(this.superUser || this.adminUser)) {
			window.location.href = '/home';
		}

		const super_token = Boolean(localStorage.getItem('superUser'));

		this.loading$ = this.store.pipe(
			select(fromUserSelectors.selectUsersLoading)
		);

		this.store
			.pipe(select(fromUserSelectors.selectUsersList))
			.subscribe((list: Employees) => {
				if (list !== null) {
					this.list = list.Users;
					if (super_token) {
						this.getUsersB2G();
					} else {
						this.getUsers();
					}
				}
			});

		this.initPassForm();
	}

	private portugueseRangeLabel(
		page: number,
		pageSize: number,
		length: number
	): string {
		if (length === 0 || pageSize === 0) {
			return `0 de ${length}`;
		}

		length = Math.max(length, 0);

		const startIndex = page * pageSize;

		const endIndex =
			startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;

		return `${startIndex + 1} - ${endIndex} de ${length}`;
	}

	private translateTable() {
		this.paginatorTranslator.itemsPerPageLabel = 'Itens por página:';
		this.paginatorTranslator.nextPageLabel = 'Página seguinte';
		this.paginatorTranslator.previousPageLabel = 'Página anterior';
		this.paginatorTranslator.firstPageLabel = 'Primeira página';
		this.paginatorTranslator.lastPageLabel = 'Última página';
		this.paginatorTranslator.getRangeLabel = this.portugueseRangeLabel;
	}

	private initPassForm(): void {
		this.searchForm = this.fb.group({
			search: [''],
		});
	}

	private getUsers(): void {
		this.users = [];

		this.list.forEach((user: UserManagement) => {
			let init = '';
			if (user.name) {
				init = this.initials(user.name);
			}
			const newUser = {
				name: user.name,
				role: user['custom:role'],
				email: user.email,
				initial: init,
			};
			this.users.push(newUser);
		});

		this.dataSource = new MatTableDataSource<any>(this.users);
		this.dataSource.paginator = this.paginator;
		this.loading = false;
	}

	private getUsersB2G(): void {
		this.users = [];

		this.list.forEach((user: any) => {
			let init = '';

			if (this.search(user.Attributes, 'name')) {
				init = this.initials(this.search(user.Attributes, 'name'));
			}

			const role = this.search(user.Attributes, 'custom:role');
			const locale = this.search(user.Attributes, 'locale');
			const email = this.search(user.Attributes, 'email');
			const name = this.search(user.Attributes, 'name');
			const sub = this.search(user.Attributes, 'sub');

			const organization = this.search(user.Attributes, 'custom:organization');

			const newUser = {
				name,
				role,
				email,
				initial: init === '' ? 'UF' : init,
				organization,
				locale,
				sub,
			};

			this.users.push(newUser);
		});

		const aux = [...this.users];

		this.dataSource = new MatTableDataSource<any>(aux);
		this.dataSource.paginator = this.paginator;
		this.loading = false;
	}

	private search(myArray: any, nameKey: string): string {
		for (const element of myArray) {
			if (element.Name === nameKey) {
				return element.Value;
			}
		}
		return 'Undefined';
	}

	public filterUser(): void {
		const filter = this.searchForm.value.search;
		this.dataSource.filter = filter.toLowerCase();
	}

	private updateUsersOnStore(): void {
		const super_token = Boolean(localStorage.getItem('superUser'));

		if (super_token) {
			this.store.dispatch(fromUserActions.doLoadUsersSuper());
		} else {
			this.store.dispatch(fromUserActions.doLoadUsersStandard());
		}
	}

	public openNewUserModal(): void {
		const dialog = this.dialog.open(UserCreateComponent, {
			panelClass: 'modal-css',
		});

		dialog.afterClosed().subscribe(() => {
			this.updateUsersOnStore();
		});
	}

	public initials(value: string): any {
		const names = value.split(' ');
		const initials = names.map((name: string) => name.charAt(0).toUpperCase());
		if (initials.length > 1) {
			return `${initials[0]}${initials[initials.length - 1]}`;
		} else {
			return initials[0];
		}
	}

	public translateUserRole(role: string): string {
		if (role == 'OP') {
			return 'operador';
		} else if (role == 'ADMIN') {
			return 'administrador';
		}
	}

	public editUser(data: any): void {
		const dialog = this.dialog.open(UserCreateComponent, {
			panelClass: 'modal-css',
		});
		const instance = dialog.componentInstance;
		instance.user = data;
	}

	public deleteUser(data): void {
		const super_token = Boolean(localStorage.getItem('superUser'));
		const dialog = this.dialog.open(ConfirmationDeleteComponent);
		const selected = this.list.filter((e) => e.Username === data.sub);

		dialog.afterClosed().subscribe((response) => {
			if (response === true) {
				if (super_token) {
					this.superService
						.deleteAdmin(data)
						.subscribe()
						.add(() => {
							this.users = [];
							this.list = this.list.filter((e) => e !== selected[0]);

							let userAttributes = selected[0].Attributes;
							let userRole: string = 'OP';

							userAttributes.forEach((elem: Object) => {
								if (elem['Name'] == 'custom:role') {
									userRole = elem['Value'];
								}
							});

							this.updateUsersOnStore();
							this.getUsersB2G();

							this.toastr.success(
								'O ' +
									this.translateUserRole(userRole) +
									' foi deletado com sucesso.'
							);
						});
				} else {
				}
			}
		});
	}
}
